import React, { useState } from 'react';
import { Checkbox } from 'cantarus-react-ui';




const FieldDataCheckbox = ({ fieldKey, fieldName, fieldValue, handleFieldDataTextChange }) => {

    const [checked, setChecked] = useState((typeof fieldValue === 'boolean') && fieldValue)

    const handleChange = () => {
        handleFieldDataTextChange(fieldName, !checked);
        setChecked(!checked)
    }

    return (
        <Checkbox
            value={checked}
            onChange={handleChange}
            toggle />
    );
}

export default FieldDataCheckbox;
